import React from "react";
import { TitleBlock, Field, Actions, PrimaryBtn } from "../../../../auth/v2/pieces";
import { TIERS, REGIONS_BY_TIER } from "../../../../ForBusiness/Cacheshare/taxonomy";
import { ChoiceChips } from "../coachOnboardingPieces";
import { canContinue } from "../coachOnboardingModel";

// 06 · Tier and region. College has no regions, so the field hides. Region
// is optional (a second click clears it): without one the team list spans
// every region of the tier.
const TierRegionStep = ({ filters, onChange, onContinue }) => {
  const regions = REGIONS_BY_TIER[filters.tier?.value] || [];
  return (
    <>
      <TitleBlock eyebrow="Tier & Region" title="Where do you compete?" />
      <Field label="Tier" hint="Selecting a new tier resets the filters below.">
        <ChoiceChips label="Tier" options={TIERS} value={filters.tier?.value} onChange={(v) => onChange({ tier: TIERS.find((t) => t.value === v) || null })} />
      </Field>
      {regions.length > 0 && (
        <Field label="Region">
          <ChoiceChips label="Region" clearable options={regions} value={filters.region?.value} onChange={(v) => onChange({ region: regions.find((r) => r.value === v) || null })} />
        </Field>
      )}
      <Actions>
        <PrimaryBtn disabled={!canContinue("tier", filters)} onClick={onContinue}>
          Continue
        </PrimaryBtn>
      </Actions>
    </>
  );
};

export default TierRegionStep;
